import React from 'react';
import { useInViewAnimation } from '../hooks/useInViewAnimation';

const stack = [
  'React', 'Next.js', 'TypeScript', 'Node.js', 'Express.js', 'Python',
  'FastAPI', 'PostgreSQL', 'MongoDB', 'Docker', 'AWS', 'Azure',
  'OpenAI', 'Claude', 'Gemini', 'LangChain', 'Redis'
];

export function TechStackSection() {
  const { ref, isInView } = useInViewAnimation();

  return (
    <section
      ref={ref}
      data-testid="tech-stack-section"
      className="max-w-[1200px] mx-auto px-6 py-16 md:py-20"
    >
      <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-6 mb-10 md:mb-14">
        <h2
          className={`text-[32px] md:text-[40px] lg:text-[44px] leading-[1.1] text-[#0D212C] tracking-tight ${isInView ? 'animate-fade-in-up' : 'opacity-0'}`}
          style={{ animationDelay: '0.05s' }}
        >
          Our <span className="font-serif grad-text">Technology Stack</span>
        </h2>
        <p
          className={`text-sm md:text-base text-[#273C46] max-w-md ${isInView ? 'animate-fade-in-up' : 'opacity-0'}`}
          style={{ animationDelay: '0.15s' }}
        >
          The tools we use every day to ship enterprise-grade software, AI systems and cloud platforms.
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4">
        {stack.map((tech, i) => (
          <div
            key={tech}
            className={`group relative rounded-2xl bg-white border border-[#7C3AED]/10 px-4 py-5 text-center shadow-[0_2px_10px_rgba(0,0,0,0.03)] hover:shadow-[0_10px_36px_rgba(109,40,217,0.25)] hover:-translate-y-1 hover:border-[#7C3AED]/40 transition-all duration-300 ${isInView ? 'animate-fade-in-up' : 'opacity-0'}`}
            style={{ animationDelay: `${0.1 + i * 0.03}s` }}
            data-testid={`tech-card-${tech.toLowerCase().replace(/[.\s]/g, '-')}`}
          >
            <span className="font-mono font-medium text-sm md:text-base text-[#0D212C] group-hover:text-[#4C1D95]">
              {tech}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
